import React from "react";

const Payments = ( {data} ) => {
    return(
        <div className="flex flex-col md:gap-8 gap-2 leading-tight">
            <span className="flex font-medium md:text-[40px] text-[24px] " style={{color: data.payments.title_color}}>{data.payments.title}</span>
            <div className="grid md:grid-cols-[3.05fr_3fr] grid-cols-1  lg:gap-24 md:gap-6 gap-3">
                <div className="grid grid-cols-[0.5fr_3fr_2fr] font-medium">
                    {
                        data.payments.card.map( (card, index) => (
                            <>
                            <hr className="my-5 col-span-3" style={{borderColor: card.line_color}}/>
                                <span className="flex md:text-[16px] text-[20px] mt-1" style={{color: card.index_color}}>
                                    {card.index}
                                </span>
                                <div className="flex flex-col gap-3">
                                    <span className="flex md:text-[24px] text-[20px]" style={{color: card.title_color}}>
                                        {card.title}
                                    </span>
                                    <span className="flex text-[16px]" style={{color: card.desc_color}}>{card.desc}</span>
                                </div>
                                <img className="flex justify-self-end items-end" src={card.image} alt=""/>
                            </>
                        ))
                    }
                </div>
                <div className="flex flex-col p-6 mt-5 justify-between rounded-3xl bg-no-repeat bg-right-bottom bg-contain gap-16 h-fit" 
                        style={{backgroundColor: data.payments.conversion_bg_color, backgroundImage: `url("${data.payments.conversion_bg_image}")`, 
                        backgroundSize: '65%'}}
                    >
                    <div className="flex lg:flex-row flex-col justify-between lg:gap-5 gap-2">
                        <span className="md:text-[32px] text-[24px]" style={{color: data.payments.title_conversion_color}}>
                            {data.payments.title_conversion}
                        </span>
                        <div className="flex gap-2">
                            {
                                data.payments.currencies.map( (currencies,index) =>(
                                    <span className="flex font-medium lg:text-[20px] text-[16px] items-center justify-center 
                                            md:px-5 lg:py-0 md:py-1.5 px-4 py-0.5 rounded-3xl" 
                                            style={{color: currencies.currency_color , backgroundColor: currencies.bg}}
                                        >
                                        {currencies.currency}
                                    </span>
                                ))
                            }
                        </div>
                    </div>
                    <div className="flex flex-col md:gap-10 gap-8" >
                            {
                                data.payments.main_info.map((main_info, index) => (
                                    <div className="flex flex-col">
                                        <div className="flex font-meduim items-end gap-2" style={{color: main_info.color}}>
                                            <span className="text-[20px] mb-2">{main_info.txt}</span>
                                            <span className="md:text-[40px] text-[32px]">{main_info.numbers}</span>
                                        </div>
                                        <span className="md:text-[20px] text-[14px] font-meduim" style={{color: main_info.color}}>
                                            {main_info.text}
                                        </span>
                                    </div>
                                ))
                            }
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Payments;